<template>
	<div @drop.prevent="dropFile($event)" @dragover.prevent @dragenter.prevent class="drop-area is-marged-left is-marged-right">
		<button @click="btnClick" type="button" :class="classes">{{ buttonText }}</button>
		<input type="file" :name="name" :ref="name" @change="uploadFile" class="is-hidden" tabindex="-1" :accept="fileFormats">
		<div class="is-size-7 is-marged-bottom">{{notice}}</div>
	</div>
</template>

<script>
	export default {
		props: {
			fileFormats: String,
			fileFormatError: String,
			multipleFilesError: String,
			name: String,
			classes: String,
			buttonText: String,
			notice: String,
		},
		data: function ()
		{
			return {
				regex: new RegExp('(' + this.fileFormats
					.replaceAll('.', '\\.')
					.replaceAll(',', '|') + ')$', 'i')
			}
		},
		methods: {
			btnClick: function ()
			{
				$('input[name="' + this.name + '"]').val(null);
				$('input[name="' + this.name + '"]').click();
			},
			dropFile: function (event)
			{
				$('.drop-area').removeClass('dragging');
				cleanFlashAlert();
				if (event.dataTransfer.files.length !== 1)
				{
					addFlashAlert('danger', this.multipleFilesError);
					return;
				}
				if (!this.regex.exec(event.dataTransfer.files[0].name))
				{
					addFlashAlert('danger', this.fileFormatError);
					return;
				}
				this.$refs[this.name].files = event.dataTransfer.files;
				this.uploadFile();
			},
			uploadFile: function ()
			{
				this.$emit('change',this.$refs[this.name]);
			}
		},
		mounted() {
			$('.drop-area').on("dragover", (event) => {
				$('.drop-area').addClass('dragging');
			});
			$('.drop-area').on("dragend", (event) => {
				$('.drop-area').removeClass('dragging');
			});
			$('.drop-area').on("dragleave", (event) => {
				$('.drop-area').removeClass('dragging');
			});
		},
	}
</script>

<style scoped>
.drop-area
{
	border: 2px gray dashed;
}
.drop-area.dragging
{
	background-color: palegoldenrod;
}
</style>
